import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

import "./PrivacyPolicy.css";

const PrivacyPolicy: React.FC = () => {
  return (
    <>

<title>Finsall Privacy Policy Overview</title>
<meta
  name="description"
  content="Read how Finsall manages, secures and uses customer data across its premium finance and digital insurance EMI services."
/>

      <Header />

      <div className="privacy-top-strip" />

      <section className="privacy-section">
        <div className="privacy-container">

          <h1 className="privacy-title">
            Privacy Policy
          </h1>

          <p className="privacy-updated">
            <strong>
              Finsall Privacy Policy Last Updated: 4th October, 2019
            </strong>
          </p>

          {/* Content starts here */}

          <p>This policy is published by virtue of a legal requirement
							under the provisions of the Information Technology Act, 2000 that
							require intermediaries to publish the rules and regulations,
							privacy policy and terms for access or usage of our Website and
							is primarily governed by Rule 3 (1) of the Information Technology
							(Intermediaries Guidelines) Rules, 201 Commitment Finsall intends
							to protect the privacy of its users and members on its website
							being https://www.finsall.com (our Website) and the privacy of
							the data provided by them to Finsall from time to time.</p>
						<p>The privacy of our website users, whether you are our
							former or existing registered user or merely a visitor to our
							Website, is important to us and we are strongly committed to your
							right to privacy and to keeping your personal and other
							information secure. We encourage you to read our privacy
							statement to understand what types of personally identifiable
							information we collect and how we use this information.</p>
						<p>By using Finsall website, user gives their consent that
							Finsall could collect, disclose, share, and use user's
							information in accordance with the terms of this privacy policy,
							also user consented to be bound by the terms and conditions of
							this Privacy Policy.
						</p>
						<p>If case where user does not wish/wants Finsall to collect,
							disclose, share and use users' information, including but not
							limited to any personal information (as defined below), user may
							choose not to register for an account or terminate their account
							with Finsall in accordance with the applicable Terms and
							Conditions available at the website.</p>
						<p>
							<strong>What type of information does Finsall.com
								collect from you?</strong>
						</p>
						<p>Personal Information For the purpose of providing you
							services, we require you to enroll yourself on our Website and
							get yourself registered.</p>
						<ol>
							<li>
								<p>If you choose to become a registered member of our
									Website, you are required to share your name, e-mail address,
									gender, date of birth, postal address, phone number, a unique
									login name, password, password validation, income tax details,
									marital status, details, family details, business information
									and other details shared via application form or via email or
									via any other medium (Personally Identifiable Information).</p>
							</li>
							<li>
								<p>Finsall may also collect other information specific to
									provide you service each time such as name, bank statements,
									KYC documents, personal details, business details, income tax
									details, marital status, family details and other information
									via application form or via email or via any other electronic
									medium or via printed form (Service Information).</p>
							</li>
							<li>
								<p>Additionally, Finsall collects your other details
									including but not limited to your feedback, suggestions, views,
									opinions, etc. shared on our Website (User Information) that
									may be shared/volunteered by you on our discussion forums or
									other pages of our Website. Such information being in the
									public domain is available for access for all our Website's
									users and visitors. You are advised to exercise discretion
									before you make such details public, as such information is
									vulnerable to misuse and can be easily misused. Finsall in this
									regard fully disclaims any liability (ies) or claim(s), which
									may arise by use/misuse of User Information shared by you, by
									any third party or any party not known to Finsall.</p>
							</li>
							<li>
								<p>Information exchanged by you with Finsall in the form of
									written communication, responses to emails, feedback required
									from you, participation in discussions, etc. is handled with
									confidentiality and is available for the exclusive use of
									Finsall. Please note that Finsall DOES NOT trade or sell your
									Personal Information in any manner, except as specified herein,
									or if express consent is sought from you. Non-Personal
									Information Finsall also collects certain other information
									from you on your visit to our Website such as your information
									about your operating system, browser type, the URL of the
									previous web site you visited, your internet service provider
									and your IP Address (Non-personal Information). This
									information cannot be easily used to personally identify you.</p>
							</li>
						</ol>
						<p>We use Non-personal Information for the purposes including
							but not limited to troubleshoot connection problems, administer
							the Website, analyze trends, gather demographic information, to
							ascertain how our visitors use our website, including information
							relating to the frequency of visits to our web site, average
							length of visits, pages viewed during a visit, ensuring
							compliance with the applicable law, co-operating with law
							enforcement activities, etc. This information is used to improve
							the site content and performance. You also agree that Finsall may
							gather usage statistics and usage data from your use of our
							Website to evaluate your use of our products/services, to improve
							our products/services, Website content and to ensure that you are
							complying with the terms of the applicable agreements between you
							and Finsall.</p>
						<p>The statistics and data collected may or may not be
							aggregated. These statistics contain no information that can
							distinctly identify you. We may in future also share this
							information with third party service providers or third party
							advertisers to measure the overall effectiveness of our online
							advertising, content, programming and for other bonafide purpose,
							as we may desire.</p>
						<p>By usage of our Website you expressly permit Finsall to
							access such information for one or more purposes deemed fit by
							Finsall. Cookies Similar to other commercial web sites, our
							Website utilizes standard technology called "Cookies" and Web
							server logs to collect information about how our Website is used.
							Cookies are small pieces of information that are stored by your
							browser on your computer's hard drive. Cookies are only read by
							the server that places them, and are unable to inter alia run
							programs on your computer, plant viruses or harvest your personal
							information. Cookies allow Web servers to recognize your computer
							each time you return to our Website including the date and time
							of visits, the pages viewed, time spent at our Website, and the
							Websites visited just before and just after our Website, verify
							your registration or password information (in case of registered
							users) during a particular session so that you do not have to
							input your password multiple times as you navigate the site and
							suggest products or services that may interest you.</p>
						<p>This information is collected on an aggregate basis. None
							of this information is associated with you as an individual. Most
							web browsers automatically accept cookies. By changing the
							options on your web browser or using certain software programs,
							you can control how and whether cookies will be accepted by your
							browser. Finsall understands and supports your right to block any
							unwanted Internet activity, especially that of unscrupulous
							websites. However, blocking Finsall cookies may disable certain
							features on our Website and may make it impossible for you to use
							certain services available on our Website Session Data.</p>
						<p>We automatically log generic information about your
							computer's connection to the Internet, which we call "session
							data", that is anonymous and not linked to any personal
							information. Session data consists of information such as the IP
							address, operating system, type of browser software being used by
							you and the activities conducted by you on our Website. An IP
							address is a number that lets computers attached to the Internet,
							such as our web servers, know where to send data back to the
							user, such as the pages of the site the user wishes to view. We
							collect session data because it helps us analyze things such as
							the items visitors are likely to click on most, the manner in
							which visitors click preferences on our Website, number of
							visitors surfing to various pages on the site, time spent by the
							visitors on our Website and frequency of their visit.</p>
						<p>It also helps us diagnose problems with our servers and
							lets us better administer our systems. Although such information
							does not identify any visitor personally, it is possible to
							determine from an IP address a visitor's Internet Service
							Provider (ISP), and the approximate geographic location of his or
							her point of connectivity. Other We may from time to time add or
							enhance products/services available on our Website. To the extent
							these products/services are provided to and used by you, we will
							use the information you provide in this regard to facilitate the
							products/service requested. For example, if you email us with a
							question, we will use your email address, name, nature of the
							question, etc. to respond to your question.</p>
						<p>We may also store and publish such information to assist us
							in making the site the better and easier to use. Promotional
							Initiatives Finsall may have presence on social networking
							websites including but not limited to LinkedIn, Facebook,
							Twitter, YouTube and blogs which are promotional and business
							initiatives to connect to a larger group of people. The domain
							links contained therein may either direct you to our Website or
							request your participation by way of feedback, suggestions.
							Finsall in this regard fully disclaims any liability (ies) or
							claim(s), which may arise by use/misuse of your feedback,
							suggestions, views, etc. on any of the aforementioned networking
							websites or blogs, by any third party whether or not known to
							Finsall.</p>
						<p>
							<strong>Retention of Data</strong>
						</p>
						<p>After termination of user account, Finsall shall destroy
							all the data collected from user, except the records and the data
							pertaining to the transactions undertaken using Finsall services
							on the website, and where required to ensure compliance with
							applicable laws. Please note that under the applicable laws,
							Finsall may maintain record of the transactions with Finsall,
							including personal data such as username, contact details, etc.
							Subject to the above, Finsall will delete all other Personal
							Information including the banking details (debit/credit card),
							and passwords of user when user account is terminated.offered to
							you by Finsall, etc.</p>
						<p>
							<strong>Sharing of data</strong>
						</p>
						<p>
							We may appoint following sub-contractors or technology service
							providers to facilitate Credit Facilities with whom Your data
							will be shared with -<br/>
						<li>Digiotech Solutions Pvt Ltd</li>
						<li>Cashfree Payments India Pvt Ltd</li>
						<li>Juspay Technologies Pvt Ltd</li>
						<li>Novopay Solutions Pvt Ltd</li>
						<li>Signzy Technologies Pvt Ltd</li>
						<li>TATA Teleservices Ltd</li>
						<li>Surepass Technologies Pvt Ltd</li>
						<li>Genhex Ai technologies Pvt Ltd</li>
						<li>Jiohaptik Technologies Pvt Ltd</li>
						<li>Gupshup Technologies Pvt Ltd</li>
						<li>Hyperverge Technologies Pvt Ltd</li>
						<li>Moshpit Technologies Pvt Ltd.</li>
						</p>
						<p>
							<strong>Does Finsall protect my Personal Information?</strong>
						</p>
						<p>Finsall is committed to protecting the privacy and the
							confidentiality of your Personal Information. Whenever Finsall
							obtains Personal Information from you, our Website uses
							commercially reasonable efforts and general industry standards to
							protect it from any unauthorized access or disclosure. Access to
							your Personal Information is limited to Finsall is personnel and
							such authorized third parties who may host your data on our
							behalf or may assist us in providing the products and services
							requested by you.</p>
						<p>Finsall uses its best endeavors to maintain physical,
							electronic and procedural safeguards that aim to protect your
							information against loss, misuse, damage, modification, and
							unauthorized access or disclosure. However, Finsall assumes no
							liability whatsoever for any disclosure of Personal Information
							due to unauthorized third party access or other acts of third
							parties, or any other acts or omissions beyond reasonable control
							of Finsall.</p>
						<p>
							<strong>Does Finsall secure the content its users post
								from other users?</strong>
						</p>
						<p>The content that you store, post, or transmit on or through
							our Website, may be accessed by other users (registered or
							unregistered), including people that you do not know. The
							content/images that you post/share on our Website may be prone to
							misuse by a party not known to you. Finsall in this regard fully
							disclaims any liability (ies) or claim(s), which may arise by
							use/misuse of such content, by any third party or any party not
							known to Finsall.</p>
						<p>We suggest that you exercise care and caution in
							communicating with other users and only disclose your information
							to other users that you know to be trustworthy. You should not
							assume that your content will be kept private.</p>
						<p>
							<strong>How does Finsall use the information that it
								collects? </strong>
						</p>
						<p>Any information share by you is used by us and/or
							authorized third parties/service partners to support your
							interaction with us, to offer you services in the best possible
							manner and to contact you again about other services and products
							that we offer. You acknowledge that the third-party service
							provider/banks/ NBFCs/ agent/agencies will have access to your
							personal information on a need to know basis to assist us in
							rendering Services required.The third-party service providers are
							obligated not to disclose or use the information for any other
							purpose. By submitting your Personal Information to Finsall, you
							expressly acknowledge and consent to Finsall to use such
							information and to process the same in a manner deemed fit by
							Finsall. This may involve conducting data analysis, research
							based on reviews about deals, transfer of your Personal
							Information to third party experts for the purpose of outsourcing
							services offered to you by Finsall, etc.</p>
						<p>
							<strong>Permissions</strong>
						</p>
						<p>Certain permissions are being sought by Finsall, from the
							consumer at the event of downloading the application,
							registration or requesting for loan.</p>
						<li>Camera Access - to capture the individual image, check
							the liveliness and authentication of the applicant. The incident
							may be termed as "Selfie"</li>
						<li>Location - This area specific permission helps understand
							and filter location which are marked as negative/ sensitive for
							lending.</li>
						<li>Microphone - to complete the process of onboarding</li>
						<p>
							<strong>User Discretion</strong>
						</p>
						<p>By using the Website and/ or by providing your information,
							User consent to the collection and use of the information User
							disclose on the Website in accordance with this Privacy Policy,
							including but not limited to User consent for collecting, using,
							sharing and disclosing your information as per this privacy
							policy.</p>
						<p>User can always choose not to provide information, which is
							not mandatory in nature but in case the information required is
							mandatory and user did wish not to provide the requisite
							information, then user will not be able to access the app/web or
							the service fully.</p>
						<p>
							<strong>What security precautions are in place to
								protect against the loss, misuse, or alteration of your
								information?</strong>
						</p>
						<p>Finsall makes every reasonable effort to preserve the
							privacy and confidentiality of your information shared with us.
							We implement standard measures to protect against unauthorized
							access to and unlawful interception of Personal Information.
							However, no Internet site can fully eliminate security risks.</p>
						<p>We reserve the right to disclose information shared by you
							without your consent (express or implied) and without any
							liabilities to you when required or permitted by law and we have
							a good-faith belief that</p>
						<ol>
							<li>
								<p>
									such action is necessary to comply with an appropriate law
									enforcement investigation, current judicial proceeding, a court
									order or legal process served on us<br/> or
								</p>
							</li>
							<li>
								<p>to conform to the legal requirements,
									compliance/reporting to administrative and judicial
									authorities, as may be required</p>
							</li>
							<li>
								<p>protect and defend the rights or property of the website
									owners of Finsall, or the users of Finsall, (iv) person(s) or
									company (ies) who provide certain support services to us, and
									(v) person(s) or company (ies) who share certain
									responsibilities/obligations of Finsall.</p>
							</li>
						</ol>
						<p>Further, we reserve the right to disclose information
							shared by you with your consent with entities engaged in
							providing the credit scores or credit information related
							services like CIBIL, etc. I have more questions about privacy
							policy If you have any questions about this Privacy Policy, the
							practices of this site, or your dealings with this site, please
							contact us at mailto:grievance@finsall.com.</p>
						<p>
							<strong>CREDIT INVESTIGATION</strong>
						</p>
						<p>
							You accept and agree that Finsall shall, based on your explicit
							consent, obtain Your credit scores or credit information reports
							from Credit Information Companies (the "CICs") directly or
							through its technology service providers that we have
							contractually partnered with authorized under applicable laws as
							Your lawful and duly authorised/ appointed agent. You also
							acknowledge that You shall not raise any claim or hold liable our
							Partner CIC's or service providers in relation to Your credit
							information report and credit score provided or to be provided by
							Partner CIC's. You also agree to these consent form for CICs
							being the terms and conditions of our Partner CICs for
							authorizing the Partner CICs to furnish Your credit information
							to Finsall. <br/>
							<br/> You hereby agree and acknowledge that the Lending
							Partners shall, based on their independent arrangement with CICs,
							directly obtain detailed credit information of the User, prior to
							providing the loan facility through the Finsall LSP Services. It
							is expressly clarified and communicated that Finsall shall not be
							liable for any effects on the User's credit score resulting due
							to any Lending Partners' obtaining the User's detailed credit
							information from the CICs. <br/>
							<br/> You hereby accept and agree that Finsall shall ,
							retain, store, use, analyze, aggregate, Your credit score and
							credit information obtained from Partner CICs for the following
							purposes: <br/>
							<br/> a. To present an overview of Your credit score and
							credit information report obtained from the CICs; <br/> b. To
							identify and inform You with tailored/ personalized offers for
							EMI or loan offers from our Lending Partners and financial
							institutions that may be suitable to Your circumstances.<br/>
							<br/> For the sake of abundant clarity it is clarified that
							any delay or default in payments to the Financing Partners can
							lead to a negative impact on Your credit score. You categorically
							accept and agree that You shall not hold Finsall responsible for
							any adverse impact on Your credit score resulting from Your
							access or use of the Finsall LSP Services.<br/>
							<br/> Accordingly, the information provided/ displayed to You
							are on "As Is" and "As Available" basis. Please note that Finsall
							does not control Your credit score and/or credit information
							report, which is a statistical analysis of information contained
							in Your credit file as maintained in the system and database of
							Partner CICs, and we cannot change that information for You.
							Neither does Finsall guarantee the timeliness, accuracy or
							correctness of any information contained in Your credit score
							and/or credit information report nor shall it accept any
							liability, whatsoever, for any errors, inaccuracies or omissions
							in Your credit score and/or credit information report or any
							information provided/ displayed to You, basis Your credit score
							and credit information report.<br/>
							<br/> If You believe that any information in Your credit
							information report is inaccurate and is affecting Your score, You
							may dispute the same by directly contacting the concerned Partner
							CIC through its website.<br/>
							<br/> We agree to protect and keep confidential Your credit
							score and credit information report, both online and offline. We
							collect, use and disclose information about You as per our
							Privacy Policy. We recommend You go through our Privacy Policy to
							understand the same.
						</p>
						<p>
							<strong>Will Finsall change privacy policy in the
								future?</strong>
						</p>
						<p>This policy provides a general statement of the ways in
							which Finsall aims to protect your information. You may, however,
							in connection with specific products or services offered by
							Finsall, be provided with privacy policies or statements that
							substitute or supplement this policy. The terms and conditions of
							this policy may be changed from time to time, without your
							consent (express or implied) to reflect changes in our practices
							concerning the collection and use of your information. The
							revised policy will be effective immediately upon posting to our
							web site unless otherwise mentioned.</p>
						<p>This version of the policy is effective from 7th October,
							2015. The revised Privacy Policy shall bind you and it is your
							sole responsibility to check the same from time to time. You
							acknowledge that no knowledge of the revised Privacy Policy shall
							be a defence in any proceedings with regard to the Privacy
							Policy.</p>
						<p>
							Your Consent By accessing our Website and using it on a continued
							basis, you expressly consent and confirm to Finsall collecting,
							maintaining, using, processing and disclosing your Personal and
							other Information in accordance with this Privacy Policy. I have
							a complaint/concern In accordance with the relevant provisions of
							the Information Technology Act, 2000 and Rules made thereunder,
							the name and contact details of the Grievance Officer who can be
							contacted with respect to any complaints or concerns including
							those pertaining to breach of Finsall's Terms of Use, Privacy
							Policy and other polices or questions are published as under:
							Grievance Officer's Email: <a
  href="mailto:compliance@finsall.com"
  target="_top"
>compliance@finsall.com</a>
							<strong>Name of the Grievance Officer : Prabal Khanna,
								Contact Number: 18005705797 </strong>
						</p>
						<p>By accepting the privacy policy, you expressly consent to
							Finsall's collection, retention, analysis, use and disclosure of
							your personal information in accordance with this privacy policy.</p>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;